export default __webpack_public_path__ + "static/media/logo_tradicional_passarela_44.1d3f5d34.png";